import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unauthorized-access-view',
  templateUrl: './unauthorized-access-view.component.html',
  styleUrls: ['./unauthorized-access-view.component.scss']
})
export class UnauthorizedAccessViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
